import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Input,
  Text,
  useDisclosure,
  useToast,
  Flex,
} from '@chakra-ui/react';
import CustomerApi from 'api/customer';

const AadhaarVerificationModal = ({
  isOpen,
  onClose,
  onVerify,
  userId,
  func,
}) => {
  const [aadhaarNumber, setAadhaarNumber] = useState('');
  const [otp, setOtp] = useState('');
  const [step, setStep] = useState(1);
  const [clientID, setClientID] = useState('');
  const [error, setError] = useState('');
  const toast = useToast();
  const toastIdRef = React.useRef();

  const generateOTP = async (id, aadhaarNumber) => {
    if (toastIdRef.current) {
      toast.close(toastIdRef.current);
    }
    try {
      const api = await CustomerApi.generateOTP({ id, aadhaarNumber });
      const response = api.data;
      if (response.status_code === 200) {
        const { client_id, url } = response.data;
        if (url) {
          window.open(url, '_blank');
        }
        onClose();
        func();
        // setClientID(client_id);
        // setStep(2);
      } else {
        toastIdRef.current = toast({
          title: response.message || 'Error generating Verification OTP. Please try again.',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top',
        });
        setError(response.message);
      }
    } catch (err) {
      setError('Failed to generate OTP. Please try later.');
    }
  };

  const verifyOTP = async (clientID, id, otp) => {
    try {
      const api = await CustomerApi.verifyOTP({ id, clientID, otp });
      const response = api.data;
      if (
        response.status_code === 200 &&
        response?.data?.user_document?.aadhar_verified
      ) {
        onVerify(true);
        onClose();
        func();
      } else {
        toastIdRef.current = toast({
          title: response.message || 'Error validating OTP. Please try again.',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top',
        });
        setError('OTP verification failed. Please check and try again.');
      }
    } catch (err) {
      setError('Failed to verify OTP. Please try later.');
    }
  };

  const handleAadhaarSubmit = () => {
    if (aadhaarNumber.length === 12) {
      setError('');
      generateOTP(userId, aadhaarNumber);
    }
  };

  const handleOtpSubmit = () => {
    if (otp.length === 6) {
      setError('');
      verifyOTP(clientID, userId, otp);
    }
  };

  const handleClose = () => {
    // Reset the state when modal closes
    setAadhaarNumber('');
    setOtp('');
    setStep(1);
    setError('');
    onClose();
    func();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Verify Aadhaar</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {error && <Text color='red.500'>{error}</Text>}
          {step === 1 ? (
            <>
              <Text>Enter your 12-digit Aadhaar number:</Text>
              <Input
                value={aadhaarNumber}
                onChange={(e) => setAadhaarNumber(e.target.value)}
                placeholder='Aadhaar Number'
                maxLength={12}
                mt={4}
              />
              <Button
                mt={4}
                colorScheme='blue'
                onClick={handleAadhaarSubmit}
                isDisabled={aadhaarNumber.length !== 12}
              >
                Verify
              </Button>
            </>
          ) : (
            <>
              <Text>
                Enter the OTP sent to your Aadhaar-linked mobile number:
              </Text>
              <Input
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder='OTP'
                maxLength={6}
                mt={4}
              />
              <Button
                mt={4}
                colorScheme='blue'
                onClick={handleOtpSubmit}
                isDisabled={otp.length !== 6}
              >
                Verify OTP
              </Button>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button variant='ghost' onClick={handleClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AadhaarVerificationModal;
